import { Alert, Text } from '@vtex/admin-ui'
import { useSkus } from 'hooks'
import { FormattedMessage } from 'react-intl'
import { TextSpinner } from 'ui'
import { messages } from './messages'

export function AllItemsAlert() {
  const { data: skus, isLoading } = useSkus()

  return (
    <Alert variant="warning">
      <FormattedMessage
        {...messages.alert}
        values={{
          loading: isLoading,
          value: skus?.total,
          spinner: <TextSpinner variant="action1" />,
          b: (content) => <Text variant="action1">{content}</Text>,
        }}
      />
    </Alert>
  )
}
